import { render, staticRenderFns } from "./PlatformPerformance.vue?vue&type=template&id=42347bf5&scoped=true&"
import script from "./PlatformPerformance.vue?vue&type=script&lang=js&"
export * from "./PlatformPerformance.vue?vue&type=script&lang=js&"
import style0 from "./PlatformPerformance.vue?vue&type=style&index=0&id=42347bf5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42347bf5",
  null
  
)

export default component.exports